ace.define("ace/snippets/handlebars",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="handlebars"})
/*** EXPORTS FROM exports-loader ***/
module.exports = Handlebars;
